import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { YatPhoneNumberInput } from '@pkg/components';
import { DepButton } from '@pkg/components/deprecated';
import { useAppDispatch } from '@pkg/hooks';
import { TwoFactorAuthType } from '@pkg/types';

import { apiFactory } from '@app/client';
import { Auth } from '@app/client/resources';
import { addAlert } from '@app/store/slices';

interface AuthSetupPhoneNumberProps {
    onNext: (phoneNumber: string) => void;
    onSwitchType: () => void;
}

export const AuthSetupPhoneNumber = ({ onNext, onSwitchType }: AuthSetupPhoneNumberProps) => {
    const { t } = useTranslation(['twoFactorAuth']);
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useAppDispatch();

    const handleSetupPhoneNumber = () => {
        if (!phone) {
            return;
        }

        const provider = TwoFactorAuthType.SMS;

        setLoading(true);
        apiFactory()
            .call(Auth.enable2FA, { value: { provider, default: true, phone } })
            .then((res) => {
                if (res.ok) {
                    onNext(phone);
                    return;
                }
                dispatch(addAlert({ message: t('2fa_invalid_phone') }));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <h2 className="two-factor-auth-step__title mb-small">{t('2fa_step_setup_phonenumber_title')}</h2>
            <p className="two-factor-auth-step__detail">{t('2fa_step_setup_phonenumber_detail')}</p>
            <div className="two-factor-auth-step__inputfield">
                <YatPhoneNumberInput onChange={(value) => setPhone(value)} />
            </div>
            <DepButton
                disabled={!phone}
                loading={loading}
                classes="two-factor-auth-step__action"
                onClick={handleSetupPhoneNumber}
            >
                {t('words:next')}
            </DepButton>
            <p className="two-factor-auth-step__altaction" onClick={onSwitchType}>
                {t('2fa_step_setup_phonenumber_alt')}
            </p>
        </>
    );
};
